__turbopack_context__.v({
  "address": "WN8P4G_address",
  "addressAction": "WN8P4G_addressAction",
  "amenities": "WN8P4G_amenities",
  "amenitiesGrid": "WN8P4G_amenitiesGrid",
  "amenitiesTitle": "WN8P4G_amenitiesTitle",
  "amenitiesToggle": "WN8P4G_amenitiesToggle",
  "amenity": "WN8P4G_amenity",
  "amenityIcon": "WN8P4G_amenityIcon",
  "amenityMobileHidden": "WN8P4G_amenityMobileHidden",
  "backButton": "WN8P4G_backButton",
  "backIcon": "WN8P4G_backIcon",
  "badges": "WN8P4G_badges",
  "benefit": "WN8P4G_benefit",
  "benefitContent": "WN8P4G_benefitContent",
  "benefitDescriptionsHidden": "WN8P4G_benefitDescriptionsHidden",
  "benefitIcon": "WN8P4G_benefitIcon",
  "benefits": "WN8P4G_benefits",
  "contactButton": "WN8P4G_contactButton",
  "description": "WN8P4G_description",
  "descriptionBlock": "WN8P4G_descriptionBlock",
  "descriptionCollapsed": "WN8P4G_descriptionCollapsed",
  "descriptionToggle": "WN8P4G_descriptionToggle",
  "identity": "WN8P4G_identity",
  "locationIcon": "WN8P4G_locationIcon",
  "price": "WN8P4G_price",
  "quickFact": "WN8P4G_quickFact",
  "quickFacts": "WN8P4G_quickFacts",
  "root": "WN8P4G_root",
  "separator": "WN8P4G_separator",
  "statusBadge": "WN8P4G_statusBadge",
  "title": "WN8P4G_title",
});
